import {Invoice} from '@eitje/api'
import _ from 'lodash'

export const useInvoiceStatusFilter = ({fixedFilter}) => {
	let invoices = Invoice.useAll()

	if (fixedFilter === 'excludePaid') {
		invoices = invoices.whereNot({status: 'paid'})
	}

	const invoiceStatuses = _.uniq(invoices.map(invoice => invoice.status)).map(status => ({
		id: status,
		t: `invoices.status.${status}`,
	}))

	const filterFn = (item, filterValues) => filterValues.includes(item.status)

	return {
		items: invoiceStatuses,
		filterFn,
	}
}
